export default "__VITE_ASSET__CkoyBZPK__"